export default function toFixedIfNeeded(number, digits = 2) {
  let transformedNumber = Number(number);
  if (Math.round(transformedNumber) !== transformedNumber) {
    transformedNumber = transformedNumber.toFixed(digits);
  }
  return transformedNumber;
}
